import { useState } from 'react';
import { Button } from '@legacy/components/mui-components';
import { Stack } from '@legacy/components/ui-components/Stack';
import { Text } from '@legacy/components/ui-components/Text';
import { useTranslation } from 'react-i18next';
import { useStopTimeTracker } from '@legacy/apis/timeTrackerAPI/stop';
import { TimeTrackerPanelProps } from '../../types';
import styles from './TimeTrackerPanel.module.scss';
import { Paper } from '@mui/material';
import { displayInformation } from './displayInformation';
import { Link } from 'react-router';

const timeRegistrationUrl = '/Registration/TimeTracking?fromTracker=1';

const ActiveTimeTrackerPanel = ({
  timeTrackerData,
  handleChangeActive,
  stopPath,
}: Omit<Required<TimeTrackerPanelProps>, 'isActive' | 'isTrackingTime'>) => {
  const { t } = useTranslation('header');
  const [isStopButtonDisabled, setIsStopButtonDisabled] = useState(false);
  const { mutate: handleChangeTrackTime } = useStopTimeTracker(
    setIsStopButtonDisabled,
    stopPath,
  );

  const { heading, title, subtitle } = displayInformation(timeTrackerData);
  return (
    <Stack verticalMargin="small">
      <Stack verticalMargin="xxSmall">
        <Text bold data-automation-id="TimeTrackerHeading">
          {heading}
        </Text>
        <Text data-automation-id="TimeTrackerTitle">{title}</Text>
        <Text italic dimmed ellipsis data-automation-id="TimeTrackerSubtitle">
          {subtitle}
        </Text>
      </Stack>
      <Button
        onClick={() => handleChangeTrackTime()}
        variant="contained"
        size="small"
        data-automation-id="TimeTrackerStopButton"
        disabled={isStopButtonDisabled}
      >
        {t('TimeTrackerStopButton')}
      </Button>
      <Text>
        <Link
          to={timeRegistrationUrl}
          className={styles.TimeTrackerButton__linkText}
          onClick={handleChangeActive}
          data-automation-id="TimeTrackerSheetLink"
        >
          {t('TimeTrackerIsActiveTimesheetLink')}
        </Link>
      </Text>
    </Stack>
  );
};

const InActiveTimeTrackerPanel = ({
  handleChangeActive,
}: Pick<TimeTrackerPanelProps, 'handleChangeActive'>) => {
  const { t } = useTranslation('header');
  return (
    <Stack verticalMargin="small">
      <Text italic dimmed data-automation-id="TimeTrackerNotTrackingText">
        {t('TimeTrackerIsNotActiveTimesheetMessage')}
      </Text>
      <Text>
        <Link
          to={timeRegistrationUrl}
          className={styles.TimeTrackerButton__linkText}
          onClick={handleChangeActive}
          data-automation-id="TimeTrackerSheetLink"
        >
          {t('TimeTrackerIsNotActiveTimesheetLink')}
        </Link>
      </Text>
    </Stack>
  );
};

export const TimeTrackerPanel = ({
  isActive,
  handleChangeActive,
  timeTrackerData,
  stopPath,
}: TimeTrackerPanelProps) =>
  isActive ? (
    <div
      id="time-tracker"
      className={styles.TimeTrackerButtonContent}
      data-automation-id="TimeTrackerContent"
    >
      <Paper>
        <div className={styles.TimeTrackerButtonContentWrapper}>
          <Stack verticalMargin="small">
            {timeTrackerData ? (
              <ActiveTimeTrackerPanel
                stopPath={stopPath}
                timeTrackerData={timeTrackerData}
                handleChangeActive={handleChangeActive}
              />
            ) : (
              <InActiveTimeTrackerPanel
                handleChangeActive={handleChangeActive}
              />
            )}
          </Stack>
        </div>
      </Paper>
    </div>
  ) : null;
